import _sfc_main from "./indexPC.vue2.mjs";
/* empty css              */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "more-container" }, [_c("div", { staticClass: "more-title" }, [_c(_setup.SvgIcon, { staticClass: "email-icon", attrs: { "icon": _setup.EmailIcon } }), _c("div", { staticClass: "more-notice" }, [_vm._v(" " + _vm._s(_setup.t("If you have any questions, please email us.")) + " ")])], 1), _setup.isZH ? _c("div", { staticClass: "more-item" }, [_c("div", { staticClass: "item-title" }, [_vm._v(_vm._s(_setup.t("Join our product discussion group")))]), _c(_setup.TuiButton, { staticClass: "join-button", attrs: { "type": "primary" }, on: { "click": _setup.handleClick } }, [_vm._v(" " + _vm._s(_setup.t("Join now")) + " ")])], 1) : _vm._e(), _c("div", { staticClass: "more-item" }, [_c("div", { staticClass: "item-title" }, [_vm._v(_vm._s(_setup.t("Our email address")))]), _c("div", { staticClass: "more-content" }, [_vm._v(_vm._s(_setup.email))]), _c(_setup.SvgIcon, { staticClass: "copy-icon", attrs: { "icon": _setup.CopyIcon }, on: { "click": function($event) {
    return _setup.onCopy(_setup.email);
  } } })], 1)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "936a14d1"
);
const indexPC = __component__.exports;
export {
  indexPC as default
};
